const initialState = {
  loading: false,
  error: null,
  data: null,

  updateLoading: false,
  updateError: null,
  updateSuccess: false,

  photoUploadLoading: false,
  photoUploadError: null,
  photoUploadSuccess: false,

  sendEmailLoading: false,
  sendEmailSuccess: false,
  sendEmailError: "",

  authenticatorAppClickLoading: false,
  authenticatorAppClickData: null,
  authenticatorAppClickError: false,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USER_PROFILE_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_USER_PROFILE_SUCCESS":
      return { ...state, loading: false, data: action.payload };

    case "FETCH_USER_PROFILE_ERROR":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_USER_PROFILE_LOADING":
      return {
        ...state,
        updateLoading: true,
        updateError: null,
        updateSuccess: false,
      };

    case "UPDATE_USER_PROFILE_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
      };

    case "UPDATE_USER_PROFILE_ERROR":
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload,
      };

    case "UPLOAD_PROFILE_PHOTO_LOADING":
      return {
        ...state,
        photoUploadLoading: true,
        photoUploadError: null,
        photoUploadSuccess: false,
      };

    case "UPLOAD_PROFILE_PHOTO_SUCCESS":
      return {
        ...state,
        photoUploadLoading: false,
        photoUploadSuccess: true,
      };

    case "UPLOAD_PROFILE_PHOTO_ERROR":
      return {
        ...state,
        photoUploadLoading: false,
        photoUploadError: action.payload,
      };

    case "RESET_PROFILE_STATE":
      return initialState;
    
    case "SEND_EMAIL_VERIFICATION_CODE_LOADING":
      return {
        ...state,
        sendEmailLoading: true,
      };

    case "SEND_EMAIL_VERIFICATION_CODE_SUCCESS":
      return {
        ...state,
        sendEmailLoading: false,
        sendEmailSuccess: true,
      };
    
    case "SEND_EMAIL_VERIFICATION_CODE_ERROR":
      return {
        ...state,
        sendEmailLoading: false,
        sendEmailError: action.payload,
      };
    
    case "AUTHENTICATOR_APP_CLICK_LOADING":
      return {
        ...state,
        authenticatorAppClickLoading: true,
      };

    case "AUTHENTICATOR_APP_CLICK_SUCCESS":
      return {
        ...state,
        authenticatorAppClickLoading: false,
        authenticatorAppClickData: action.payload.body,
      };
    
    case "AUTHENTICATOR_APP_CLICK_ERROR":
      return {
        ...state,
        authenticatorAppClickLoading: false,
        authenticatorAppClickError: action.payload,
      };
    
    case "RESET_PROFILE_STATE_PHOTO":
      return {
        ...state,
        updateLoading: false,
        updateError: null,
        updateSuccess: false,
      }

    default:
      return state;
  }
};

export default profileReducer;
